<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         :width="width"
         :height="height"
         viewBox="0 0 18 18"
         :aria-labelledby="iconName"
         role="presentation"
    >
        <title :id="iconName">{{iconName}}</title>
        <g :fill="iconColor">
            <slot />
        </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: [Number, String],
      default: 16
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>

<style scoped>
    svg {
        z-index: 1;
        display: inline-block;
        vertical-align: baseline;
        margin-bottom: -2px;
    }
</style>



// WEBPACK FOOTER //
// src/components/core/Icon.vue